import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const NGsPage: React.FC = () => {
  const getBuildingNGStaffs = trpc.getBuildingNGStaffs.useQuery();
  const deleteBuildingNGStaff = trpc.deleteBuildingNGStaff.useMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (deleteBuildingNGStaff.isSuccess) {
      getBuildingNGStaffs.refetch();
    }
  }, [deleteBuildingNGStaff.isSuccess, getBuildingNGStaffs.refetch]);

  if (getBuildingNGStaffs.isPending || !getBuildingNGStaffs.data) return <LoadingData />;
  if (!getBuildingNGStaffs.data) return <ElementNotFound />;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">NGマッチング条件一覧</h2>
      <div className="overflow-x-auto py-10 bg-white border border-base-100 px-8 flex-grow flex flex-col">
        <div className="flex justify-between pb-8 flex-shrink-0">
          <button
            type="button"
            className="bg-primary-700 text-white px-4 py-2 rounded-md"
            onClick={() => navigate("/matching-ngs/new")}
          >
            新規登録
          </button>
        </div>
        <div className="overflow-y-auto flex-grow">
          <table className="min-w-full">
            <thead className="sticky top-0 bg-gray-100">
              <tr className="bg-gray-100">
                <th className="p-2 text-left border border-gray-200">従業員名</th>
                <th className="p-2 text-left border border-gray-200">物件番号</th>
                <th className="p-2 text-left border border-gray-200">物件名</th>
                <th className="p-2 text-left border border-gray-200">会社名</th>
                <th className="p-2 text-left border border-gray-200" />
              </tr>
            </thead>
            <tbody>
              {(getBuildingNGStaffs.data?.buildingNGStaffs || []).map((buildingNGStaff) => (
                <tr key={buildingNGStaff.id}>
                  <td className="p-2 text-left border border-gray-200">{buildingNGStaff.staffName}</td>
                  <td className="p-2 text-left border border-gray-200">{buildingNGStaff.buildingNumber}</td>
                  <td className="p-2 text-left border border-gray-200">{buildingNGStaff.buildingName}</td>
                  <td className="p-2 text-left border border-gray-200">{buildingNGStaff.companyName}</td>
                  <td className="p-2 text-left border border-gray-200">
                    <button
                      type="button"
                      className="text-primary-700"
                      onClick={() => {
                        deleteBuildingNGStaff.mutate({ id: buildingNGStaff.id });
                      }}
                    >
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
